import script from "./Labeling.vue?vue&type=script&setup=true&lang=js"
export * from "./Labeling.vue?vue&type=script&setup=true&lang=js"

import "./Labeling.vue?vue&type=style&index=0&id=0c535a6e&lang=css"

const __exports__ = script;

export default __exports__